module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-8"
  }, [_c('div', {
    staticClass: "card card-default widget animated"
  }, [_c('div', {
    staticClass: "card-heading"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditing),
      expression: "!isEditing"
    }],
    staticClass: "AssetViewing"
  }, [_c('div', {
    staticClass: "form-group col-md-5"
  }, [_c('p', {
    staticStyle: {
      "font-size": "35px"
    }
  }, [_vm._v(_vm._s(_vm.asset["BsNzKuUbOpA9duKR4mUg"]))]), _vm._v(" "), _vm._l((_vm.dataFields), function(dataField) {
    return _c('div', [(dataField.type === 'selector') ? _c('p', {
      staticStyle: {
        "font-size": "15px"
      }
    }, [_vm._v(_vm._s(dataField.name) + ": " + _vm._s(Object.values(_vm.asset[dataField['.key']]).join(", ")))]) : (dataField.type === 'timestamp') ? _c('p', {
      staticStyle: {
        "font-size": "15px"
      }
    }, [_vm._v(_vm._s(dataField.name) + ": " + _vm._s(_vm.unix_to_norm(new Date((_vm.asset[dataField['.key']].seconds) * 1000))))]) : _c('p', {
      staticStyle: {
        "font-size": "15px"
      }
    }, [_vm._v(_vm._s(dataField.name) + ": " + _vm._s(_vm.asset[dataField['.key']]))])])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default form-group",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Edit")])], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditing),
      expression: "isEditing"
    }],
    staticClass: "AssetEditing col-md-5"
  }, [_c('form-text', {
    ref: "assetname",
    attrs: {
      "styler": "font-size:35px",
      "label": "Asset Name",
      "name": "assetname",
      "validation": "required"
    },
    model: {
      value: (_vm.assetEdit.name),
      callback: function($$v) {
        _vm.$set(_vm.assetEdit, "name", $$v)
      },
      expression: "assetEdit.name"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitEdit
    }
  }, [_vm._v("Submit")])])], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f432452c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/assets/AssetDetail.vue
// module id = 670
// module chunks = 1